/* startedSure.icon.svg.js */

module.exports = {
    icon: `<svg viewBox="0 0 48 20" preserveAspectRatio="none">
<circle class="foreground-gl" cx="10" cy="9.8" r="2.5"/>
<circle class="foreground-gl" cx="18" cy="9.7" r="3.1"/>
<circle class="foreground-gl" cx="28.2" cy="9.8" r="3.9"/>
<path class="foreground-gl" d="M38.7,19H8.6c-4.3,0-7.8-3.5-7.8-7.8V8.7c0-4.3,3.5-7.8,7.8-7.8h30.1c1.5,0,2.9,0.4,4.2,1.2
	C43,2.2,43.1,2.4,43,2.5c-0.1,0.1-0.3,0.2-0.4,0.1c-1.2-0.7-2.5-1.1-3.8-1.1H8.6c-4,0-7.2,3.2-7.2,7.2v2.5c0,4,3.2,7.2,7.2,7.2h30.1
	c4,0,7.2-3.2,7.2-7.2V8.7c0-0.7-0.1-1.4-0.3-2.1c-0.1-0.2,0-0.3,0.2-0.4c0.2,0,0.3,0,0.4,0.2c0.2,0.7,0.3,1.5,0.3,2.2v2.5
	C46.5,15.5,43,19,38.7,19z"/>
<g>
	<path class="foreground-gl" d="M39.3,12.1C39.3,12.1,39.3,12.1,39.3,12.1c-0.3,0-0.5-0.1-0.7-0.3L35.8,8c-0.3-0.4-0.2-0.9,0.2-1.2
		c0.4-0.3,0.9-0.2,1.2,0.2l2.2,2.9l6.9-8.6c0.3-0.4,0.8-0.4,1.2-0.1c0.4,0.3,0.4,0.8,0.1,1.2L40,11.8C39.8,12,39.6,12.1,39.3,12.1z"
		/>
</g>
</svg>`
};
